import { getChannels } from 'helpers/api-calls/user-calls';
import { getLocationSettings } from 'helpers/api-calls/location-calls';
import uniqBy from 'lodash/uniqBy';
import actions from './actions';
import constants from './constants';
import moment from 'moment';
import teamCalls from 'helpers/api-calls/team-calls';
import { getPlans } from 'helpers/api-calls/plan-calls';
import { fetchUserNews, markUserNewsAsRead } from 'helpers/api-calls/user-news-calls';
import {
  requestUserNews,
  hydrateUserNews,
  setUserNewsError,
  showUserNewsModal,
  hideUserNewsModal,
  markNewsAsRead,
} from './slices/userNews';
import { GetLocationRoles } from 'helpers/api-calls/role-calls';

const { params } = constants;

const fetchChannels = (location_id) => (dispatch) => {
  dispatch(actions.requestChannels());

  return getChannels(params.getChannels(location_id)).then((response) => {
    dispatch(actions.hydrateChannels(response.data.channels));
  });
};

const fetchLocation = (user_privilege_id) => (dispatch) => {
  dispatch(actions.requestLocation());

  return getLocationSettings(user_privilege_id).then((response) => {
    dispatch(
      actions.updateSettings(
        response.data.user_privilege.final_function_setting
      )
    );
  });
};

const fetchAllUsers = (locationId,  pageNo, numPerPage) => (dispatch) => {
  // console.log('Fetch All from App Duck');

  const start = moment();
  const allUserConfig = {
    location_id: locationId,
    page: pageNo,
    per_page: numPerPage,
    with_deleted: true,
  };
  dispatch(actions.requestAllUsers(true));
  dispatch(actions.requestManagers(true));
  dispatch(actions.requestAssociates(true));
  dispatch(actions.requestPendingUsers(true));
  return teamCalls.getTeamMembersUM(allUserConfig).then((response) => {
    const noDuplicated = uniqBy(response.data.user_privileges, 'id');
    const visible = noDuplicated.filter((item) => item.is_invisible === false);
    const managers = visible.filter((item) => item.is_admin === true && item.status === 'active');
    const associates = visible.filter((item) => item.is_admin === false && item.status === 'active');
    const pendingUsers = visible.filter((item) => item.status === 'pending');
    const removedUsers = visible.filter((item) => item.status !== 'active' && item.status !== 'pending');
    const end = moment();
    const diff = moment.duration(end.diff(start))
    const ms = parseInt(diff.asMilliseconds());
    const s = `Fetch ${noDuplicated.length} users take ${ms} ms.`;
    //console.log(s);
    const payload = {
      users: noDuplicated,
      page: response.data.meta.pagination.current_page,
      totalPages: response.data.meta.pagination.total_pages,
    };
    if(allUserConfig.page === 1) {
      dispatch(actions.receiveAllUsers(payload));
    }else {
      dispatch(actions.appendAllUsers(payload));
    }

    const payloadManagers = {
      users: managers,
      page: response.data.meta.pagination.current_page,
      totalPages: response.data.meta.pagination.total_pages,
    };
    if(allUserConfig.page === 1) {
      dispatch(actions.receiveManagers(payloadManagers));
    }else {
      dispatch(actions.appendManagers(payloadManagers));
    }

    const payloadAssociates = {
      users: associates,
      page: response.data.meta.pagination.current_page,
      totalPages: response.data.meta.pagination.total_pages,
    };
    if(allUserConfig.page === 1) {
      dispatch(actions.receiveAssociates(payloadAssociates));
    }else {
      dispatch(actions.appendAssociates(payloadAssociates));
    }

    const payloadPendingUsers = {
      users: pendingUsers,
      page: response.data.meta.pagination.current_page,
      totalPages: response.data.meta.pagination.total_pages,
    };
    if(allUserConfig.page === 1) {
      dispatch(actions.receivePendingUsers(payloadPendingUsers));
    }else {
      dispatch(actions.appendPendingUsers(payloadPendingUsers));
    }
    
    const payloadRemovedUsers = {
      users: removedUsers,
      page: response.data.meta.pagination.current_page,
      totalPages: response.data.meta.pagination.total_pages,
    };
    if(allUserConfig.page === 1) {
      dispatch(actions.receiveRemovedUsers(payloadRemovedUsers));
    }else {
      dispatch(actions.appendRemovedUsers(payloadRemovedUsers));
    }
  }).catch((error) => {
    console.log(`fetAllUsers error: ${error}`);
    dispatch(actions.resetAllUsers());
    dispatch(actions.resetManagers());
    dispatch(actions.resetAssociates());
    dispatch(actions.resetPendingUsers());
    dispatch(actions.resetRemovedUsers());
  });

};


const fetchLocationRolesOperation = (locationId) => (dispatch) => {
  return GetLocationRoles(locationId)
    .then((response) => {
      dispatch(actions.hydrateRoles(response.data.tags));
    })
    .catch((error) => {
      console.error("Error fetching location roles:", error);
    });
};


const fetchPlans = (location_id) => (dispatch) => {
  dispatch(actions.requestPlans(true));
  return getPlans(location_id).then(({ data }) => {
    dispatch(actions.hydratePlans(data.plans));
  }).catch((error) => {
    console.log(`fetchPlans error: ${error}`);
  });
};

const fetchUserNewsOperation = () => (dispatch) => {
  try {
    console.log('fetchUserNewsOperation called');
    dispatch(requestUserNews());
    // Only real API call
    return fetchUserNews()
      .then(({ data }) => {
        console.log('User news API response:', data);
        if (data && data.user_news && data.user_news.length > 0) {
          const modalNews = data.user_news.find(news => news.popup === 'modal');
          if (modalNews) {
            console.log('Found modal news:', modalNews);
            dispatch(showUserNewsModal(modalNews));
          } else {
            console.log('No modal news found');
          }
          dispatch(hydrateUserNews(data.user_news));
        } else {
          console.log('No user news found');
          dispatch(hydrateUserNews([]));
        }
      })
      .catch((error) => {
        console.error('fetchUserNews error:', error);
        dispatch(setUserNewsError(error.message));
      });
  } catch (error) {
    console.error('fetchUserNewsOperation error:', error);
    dispatch(setUserNewsError(error.message));
  }
};

const markUserNewsAsReadOperation = (newsId) => (dispatch) => {
  return markUserNewsAsRead(newsId)
    .then(() => {
      dispatch(markNewsAsRead(newsId));
    })
    .catch((error) => {
      console.error('markUserNewsAsRead error:', error);
    });
};

const hideUserNewsModalOperation = () => (dispatch) => {
  dispatch(hideUserNewsModal());
};

export default {
  fetchChannels,
  fetchLocation,
  fetchAllUsers,
  fetchPlans,
  fetchUserNews: fetchUserNewsOperation,
  markUserNewsAsRead: markUserNewsAsReadOperation,
  hideUserNewsModal: hideUserNewsModalOperation,
  fetchLocationRolesOperation,
};
